import { cn } from "@/lib/utils";

export default function SiteLogo({
  site,
  size = "md",
  withText = true,
  textClassName = "",
  markClassName = "",
}) {
  const logoText = site?.logoText || site?.brand || "DEKOSTA3D";
  /** Ayarlardan URL yoksa depodaki varsayılan logo (public/logo.svg) */
  const markSrc = (site?.logoImageUrl && String(site.logoImageUrl).trim()) || "/logo.svg";

  const markSize = {
    sm: "w-8 h-8",
    md: "w-9 h-9",
  }[size] || "w-8 h-8";

  return (
    <div className="flex items-center gap-3">
      <img
        src={markSrc}
        alt={logoText}
        className={cn(`${markSize} shrink-0 object-contain dark:invert`, markClassName)}
      />
      {withText && (
        <span className={cn("font-display font-black uppercase tracking-tight", textClassName)}>
          {logoText}
        </span>
      )}
    </div>
  );
}
